import * as Yup from 'yup';
import checkoutFormModel from './formModel';
import {CardNumberValidator} from "../../../../FormikUtils/CardNumberValidator";
import moment from "moment";
import {isValidPhoneNumber} from "react-phone-number-input";

const {
    formField: {
        codigosLocalidad,
        //EMISION
        vigenciaDesde,
        vigenciaHasta,
        frecuenciaPago,
        cuotas,
        ajusteAutomatico,
        formaDePago,
        infoDePago: {
            numeroCbu,
            marcaTarjeta,
            numeroTarjeta,
        },
        bienesAsegurados: {
            id,
            descripcion,
            suma,
        },
        //CLIENTE
        rol,
        personaJuridica,
        dni,
        cuit,
        nombre,
        apellido,
        fechaNacimiento,
        estadoCivil,
        sexo,
        domicilio,
        telefono,
        email,
        situacionImpositiva,
        categoriaMonotributo,
        actividadPrincipal,
        lugarNacimiento,
        motovehiculo: {
            patente,
            motor,
            chasis,
            marca,
            version,
            anio,
            usoVehiculo,
            valorAdicional,
            valor,
            ceroKm,
            equipoDeRastreo,
            inspeccionPrevia: {
                fechaInspeccion,
                tipoCombustible,
                estadoCristales,
                resultadoInspeccion,
                kilometraje,
                colorVehiculo,
                archivos
            },
        },
    }
} = checkoutFormModel;
let tipoTarjeta;

export default [
    Yup.object().shape({
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        [nombre.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string()
                .required(`${nombre.requiredErrorMsg}`)
                .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
                .max(40, "El nombre ingresado es muy largo"),
        }),
        [apellido.name]: Yup.string()
            .when([personaJuridica.name], {
                is: '0',
                then: Yup.string()
                    .required(`${apellido.requiredErrorMsg}`)
                    .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
                    .max(40, "El valor ingresado es muy largo"),
            })
            .when([personaJuridica.name], {
                is: '1',
                then: Yup.string()
                    .required(`${apellido.requiredErrorMsg}`)
                    .matches(/^[aA-zZ.\s]+$/, "Ingrese una Razón Social válida")
                    .max(40, "La Razón Social ingresada no es valida"),
            }),
        [dni.name]: Yup.number().when([personaJuridica.name], {
            is: '0',
            then: Yup.number()
                .required(`${dni.requiredErrorMsg}`)
                .min(1000000, "El documento ingresado no es válido")
                .max(99999999, "El documento ingresado no es válido")
                .integer()
                .typeError("Introduzca únicamente números"),
        }),
        [telefono.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
    }),
    Yup.object().shape({
        motovehiculo: Yup.object().shape({
            [marca.name]: Yup.string().required(`${marca.requiredErrorMsg}`),
            [ceroKm.name]: Yup.string().required(`${ceroKm.requiredErrorMsg}`),
            [anio.name]: Yup.number()
                .required(`${anio.requiredErrorMsg}`)
                .integer()
                .min(2001, "El año ingresado es muy antiguo")
                .max(moment().format("YYYY"), "Ingrese un año válido")
                .typeError("Ingrese un año válido"),
            [version.name]: Yup.string().required(`${version.requiredErrorMsg}`),
            [patente.name]: Yup.string().test('patente', 'La patente ingresada no es válida', (value, context) => {
                const regex1 = /^[A-Z]\d{3}[a-zA-Z]{3}$/i;
                const regex2 = /^\d{3}[a-zA-Z]{3}$/i;
                const ceroKmFieldValue = context.parent.ceroKm;

                /**
                 * If ceroKmFieldValue === "true"
                 *     ? value could be undefined or (if its defined) pass the regex test
                 *     : value has to pass the regex test
                 * */
                return ceroKmFieldValue === "true"
                    ? !value || [regex1, regex2].some(e => e.test(value))
                    : [regex1, regex2].some(e => e.test(value));
            }),
            [valorAdicional.name]: Yup.number()
                .required(`${valorAdicional.requiredErrorMsg}`)
                .min(0, "El valor no puede ser negativo")
                .max(10000000, "El monto máximo es $10.000.000")
        }),


        [situacionImpositiva.name]: Yup.string().required(`${situacionImpositiva.requiredErrorMsg}`),
        [personaJuridica.name]: Yup.string().required(`${personaJuridica.requiredErrorMsg}`),

    }),
    Yup.object().shape({
        //COTIZACION SUCCESS
    }),
    Yup.object().shape({
        [nombre.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string()
                .required(`${nombre.requiredErrorMsg}`)
                .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
                .max(40, "El nombre ingresado es muy largo"),
        }),
        [apellido.name]: Yup.string()
            .when([personaJuridica.name], {
                is: '0',
                then: Yup.string()
                    .required(`${apellido.requiredErrorMsg}`)
                    .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
                    .max(40, "El valor ingresado es muy largo"),
            })
            .when([personaJuridica.name], {
                is: '1',
                then: Yup.string()
                    .required(`${apellido.requiredErrorMsg}`)
                    .matches(/^[aA-zZ.\s]+$/, "Ingrese una Razón Social válida")
                    .max(40, "La Razón Social ingresada no es valida"),
            }),
        [dni.name]: Yup.number().when([personaJuridica.name], {
            is: '0',
            then: Yup.number()
                .required(`${dni.requiredErrorMsg}`)
                .min(1000000, "El documento ingresado no es válido")
                .max(99999999, "El documento ingresado no es válido")
                .integer()
                .typeError("Introduzca únicamente números"),
        }),
        [telefono.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [rol.name]: Yup.string().required(`${rol.requiredErrorMsg}`),
        [cuit.name]: Yup.string()
            .required(`${cuit.requiredErrorMsg}`)
            .matches(/^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/, "El CUIT ingresado no es válido"),
        [fechaNacimiento.name]: Yup.date().when([personaJuridica.name], {
            is: '0',
            then: Yup.date()
                .max(new Date(Date.now() - 567648000000), "El cliente debe tener al menos 18 años para contratar")
                .required(`${fechaNacimiento.requiredErrorMsg}`),
        }),
        [estadoCivil.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${estadoCivil.requiredErrorMsg}`),
        }),
        [sexo.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${sexo.requiredErrorMsg}`),
        }),
        [domicilio.name]: Yup.string()
            .required(`${domicilio.requiredErrorMsg}`)
            .matches(/^[A-Za-z0-9 .-]+$/, "Esta utilizando carácteres no válidos"),
        // [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [situacionImpositiva.name]: Yup.string().required(`${situacionImpositiva.requiredErrorMsg}`),
        [categoriaMonotributo.name]: Yup.string().required(`${categoriaMonotributo.requiredErrorMsg}`),
        [actividadPrincipal.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${actividadPrincipal.requiredErrorMsg}`),
        }),
        [lugarNacimiento.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string()
                .required(`${lugarNacimiento.requiredErrorMsg}`)
                .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
        }),
    }),
    Yup.object().shape({ //PÓLIZA
        [formaDePago.name]: Yup.string().required(`${formaDePago.requiredErrorMsg}`),
        infoDePago: Yup.object().when([formaDePago.name], {
            is: '4',    // Débito por CBU
            then: Yup.object().shape({
                [numeroCbu.name]: Yup.string()
                    .required(`${numeroCbu.requiredErrorMsg}`)
                    .matches(/^[0-9]+$/, "Ingrese un número válido")
                    .min(22, 'El número de CBU debe tener 22 dígitos')
                    .max(22, 'El número de CBU debe tener 22 dígitos'),
            })
        }).when([formaDePago.name], {
            is: '2',    // Tarjeta de crédito
            then: Yup.object().shape({
                [marcaTarjeta.name]: Yup.string().test('cardType', 'Seleccione un tipo de tarjeta', type => {
                    tipoTarjeta = type;
                    if (tipoTarjeta !== null) return true;
                }).required(`${marcaTarjeta.requiredErrorMsg}`),
                [numeroTarjeta.name]: Yup
                    .string()
                    .test('cardNumber',
                        'El número de tarjeta ingresado es inválido', //validation message
                        value => {
                            if (tipoTarjeta === "9") {
                                if (value !== undefined && value.length === 15)
                                    return CardNumberValidator(tipoTarjeta, value)
                            } else {
                                if (value !== undefined && value.length === 16)
                                    return CardNumberValidator(tipoTarjeta, value)
                            }
                        })
                    .required()
            })
        }),

        //Por defecto
        [frecuenciaPago.name]: Yup.string().required(`${frecuenciaPago.requiredErrorMsg}`),
        [cuotas.name]: Yup.string().when([frecuenciaPago.name], {
            is: '7',
            then: Yup.string().required(`${cuotas.requiredErrorMsg}`)
        }),
        [ajusteAutomatico.name]: Yup.string().when([frecuenciaPago.name], {
            is: '7',
            then: Yup.string().required(`${ajusteAutomatico.requiredErrorMsg}`)
        }),
        [vigenciaDesde.name]: Yup.date()
            .required(`${vigenciaDesde.requiredErrorMsg}`)
            .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
            .max(moment().add(45, "days").format('YYYY-MM-DD'), "La fecha no puede superar los 45 dias"),
        [vigenciaHasta.name]: Yup.date()
            .when([frecuenciaPago.name], {
                is: '7',
                then: Yup.date()
                    .required(`${ajusteAutomatico.requiredErrorMsg}`)
                    .when([vigenciaDesde.name], (vigenciaDesde, schema) => schema.max(moment(vigenciaDesde).add(6, "M"),
                        "Las fechas deben tener una separación de 6 meses"))
            })
            .when([frecuenciaPago.name], {
                is: '7',
                then: Yup.date()
                    .required(`${ajusteAutomatico.requiredErrorMsg}`)
                    .when([vigenciaDesde.name], (vigenciaDesde, schema) => schema.min(moment(vigenciaDesde).add(6, "M"),
                        "Las fechas deben tener una separación de 6 meses"))
            })
            .when([frecuenciaPago.name], {
                is: '5',
                then: Yup.date()
                    .required(`${ajusteAutomatico.requiredErrorMsg}`)
                    .when([vigenciaDesde.name], (vigenciaDesde, schema) => schema.min(moment(vigenciaDesde).add(1, "Y"),
                        "Las fechas deben tener una separación de un año"))
            })
            .when([frecuenciaPago.name], {
                is: '5',
                then: Yup.date()
                    .required(`${ajusteAutomatico.requiredErrorMsg}`)
                    .when([vigenciaDesde.name], (vigenciaDesde, schema) => schema.max(moment(vigenciaDesde).add(1, "Y"),
                        "Las fechas deben tener una separación de un año"))
            }),
    }),
    Yup.object().shape({
        bienesAsegurados: Yup.array().of(
            Yup.object().shape({
                [id.name]: Yup.string().required(`${id.requiredErrorMsg}`),
                [descripcion.name]: Yup.string()
                    .required(`${descripcion.requiredErrorMsg}`)
                    .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                [suma.name]: Yup.number()
                    .required(`${suma.requiredErrorMsg}`)
                    .min(10000, "El monto mínimo es $10.000")
                    .max(10000000, "El monto máximo es $10.000.000")
                    .typeError("El valor ingresado no es válido"),
            })
        ),
        motovehiculo: Yup.object().shape({
            [patente.name]: Yup.string().test('patente', 'La patente ingresada no es válida', (value, context) => {
                const regex1 = /^[A-Z]\d{3}[a-zA-Z]{3}$/i;
                const regex2 = /^\d{3}[a-zA-Z]{3}$/i;
                const ceroKmFieldValue = context.parent.ceroKm;

                /**
                 * If ceroKmFieldValue === "true"
                 *     ? value could be undefined or (if its defined) pass the regex test
                 *     : value has to pass the regex test
                 * */
                return ceroKmFieldValue === "true"
                    ? !value || [regex1, regex2].some(e => e.test(value))
                    : [regex1, regex2].some(e => e.test(value));
            }),
            [motor.name]: Yup.string()
                .required(`${motor.requiredErrorMsg}`)
                .min(4, 'El número ingresado es muy corto')
                .max(20, "El número ingresado es muy largo"),
            [chasis.name]: Yup.string()
                .required(`${chasis.requiredErrorMsg}`)
                .min(4, 'El número ingresado es muy corto')
                .max(20, "El número ingresado es muy largo"),
            [marca.name]: Yup.string().required(`${marca.requiredErrorMsg}`),
            [version.name]: Yup.string().required(`${version.requiredErrorMsg}`),
            [anio.name]: Yup.number()
                .required(`${anio.requiredErrorMsg}`)
                .integer()
                .min(2001, "El año ingresado es muy antiguo")
                .max(moment().format("YYYY"), "Ingrese un año válido")
                .typeError("Ingrese un año válido"),
            [usoVehiculo.name]: Yup.string().required(`${usoVehiculo.requiredErrorMsg}`),
            [valor.name]: Yup.number()
                .required(`${valor.requiredErrorMsg}`)
                .typeError("El valor ingresado no es válido"),
            [equipoDeRastreo.name]: Yup.string().required(`${equipoDeRastreo.requiredErrorMsg}`),
            [ceroKm.name]: Yup.string().when([anio.name], {
                is: moment().format('YYYY'),
                then: Yup.string().required(`${ceroKm.requiredErrorMsg}`),
            }),
            inspeccionPrevia: Yup.object().shape({
                [fechaInspeccion.name]: Yup.date().required(`${fechaInspeccion.requiredErrorMsg}`),
                [tipoCombustible.name]: Yup.string().required(`${tipoCombustible.requiredErrorMsg}`),
                [estadoCristales.name]: Yup.string().required(`${estadoCristales.requiredErrorMsg}`),
                [resultadoInspeccion.name]: Yup.string().required(`${resultadoInspeccion.requiredErrorMsg}`),
                [kilometraje.name]: Yup.number()
                    .required(`${kilometraje.requiredErrorMsg}`)
                    .integer()
                    .typeError("El valor ingresado no es válido"),
                [colorVehiculo.name]: Yup.string()
                    .required(`${colorVehiculo.requiredErrorMsg}`)
                    .matches(/^[A-Za-z ]+$/, "Utilice letras mayúsculas y números"),
                [archivos.name]: Yup.array().min(1, "Debe Ingresar al menos un archivo")
            }),
        })
    }),
    Yup.object().shape({})
];
